import { object, string } from '@mojotech/json-type-validation'

export const judgeTokenDecoder = object({
  token: string()
})
